import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/**
 * Drop-in replacement for removed @mui/material/Hidden (MUI v6+).
 *
 * Uses the JS breakpoint path (useMediaQuery) so visible children stay in the
 * normal layout tree with no wrapper Box. A display:contents / display:block
 * wrapper broke FusePageSimple permanent Drawer flex layout (calendar sidebar
 * overlaid the main content after the MUI 6 upgrade).
 *
 * MUI semantics: *Up hides at that breakpoint and wider; *Down hides below it.
 */
function Hidden({
  children,
  lgUp,
  lgDown,
  mdUp,
  mdDown,
  smUp,
  smDown,
  xlUp,
  xlDown,
  xsUp,
  xsDown,
}) {
  const theme = useTheme();
  // Match client viewport immediately so drawers/toolbars don't flash wrong layout.
  const queryOpts = { noSsr: true };
  const upSm = useMediaQuery(theme.breakpoints.up('sm'), queryOpts);
  const upMd = useMediaQuery(theme.breakpoints.up('md'), queryOpts);
  const upLg = useMediaQuery(theme.breakpoints.up('lg'), queryOpts);
  const upXl = useMediaQuery(theme.breakpoints.up('xl'), queryOpts);

  let hidden = false;
  if (lgUp) {
    hidden = upLg;
  } else if (lgDown) {
    hidden = !upLg;
  } else if (mdUp) {
    hidden = upMd;
  } else if (mdDown) {
    hidden = !upMd;
  } else if (smUp) {
    hidden = upSm;
  } else if (smDown) {
    hidden = !upSm;
  } else if (xlUp) {
    hidden = upXl;
  } else if (xlDown) {
    hidden = !upXl;
  } else if (xsUp) {
    // xs and up === always
    hidden = true;
  } else if (xsDown) {
    hidden = !upSm;
  }

  if (hidden) {
    return null;
  }

  return children;
}

export default Hidden;
